import { render } from "./Campaign.vue?vue&type=template&id=26cd219f&scoped=true"
import script from "./Campaign.vue?vue&type=script&lang=js"
export * from "./Campaign.vue?vue&type=script&lang=js"

import "./Campaign.vue?vue&type=style&index=0&id=26cd219f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26cd219f"]])

export default __exports__